import React, { useState,useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { setUnauthenticated } from '../../utils/auth';
import {
  Carpad, CarpadParent,
  GroupInner, GroupItem, HeaderImgStyled, HomeRoot, Image3Icon, RectangleGroup
  , Slogan
  , LoginSection,
  LoginText,
  MenuLink,
  SelectedMenu,
  SelectedMenuLink
} from './styled';
import { useSessionStorage } from '../../hooks';
import Logo from '../../assets/logo.svg';


export const Header = () => {
  const navigate = useNavigate();
  const [selectedMenu, setSelectedMenu] = useState('HOME');
  const [menuData, setMenuData] = useState([
    { menu: "HOME", link: '/',selected:false }
    , { menu: "PRODUCTS", link: '/products',selected:false }
    , { menu: "ABOUT US", link: '/aboutus',selected:false }
    , { menu: "PRICING", link: '/pricing',selected:false }
    , { menu: "HOW IT WORKS", link: '/howitworks' }

  ]);
  const [authenticated] = useSessionStorage('authenticated');


  // useEffect(() => {
  //   setSelectedMenu(selectedMenu) 
  // });

  const handleMenuClick = (menu:any,index:any) => {
     
    let data=[...menuData]; 
    setMenuData([...data]);
    setSelectedMenu(menu);
  };
  return (
    <HomeRoot>

      <CarpadParent>
        <Carpad>CarPad</Carpad>
        <Slogan >Slogan goes here</Slogan>
        <GroupItem alt="" src={Logo} />
      </CarpadParent>
      <RectangleGroup>
        
        <GroupInner />
        {menuData.map((item,index) => {
          if (item.menu === selectedMenu) {
            return <SelectedMenuLink onClick={() => handleMenuClick(item.menu,index)}>
              {item.menu}
              <SelectedMenu></SelectedMenu>
            </SelectedMenuLink>
          } else {
            return   <MenuLink key={item.menu} onClick={() => handleMenuClick(item.menu,index)}>
            
                    <Link style={{textDecoration:'none',color: '#595959',fontFamily: 'Product Sans' }} to={item.link}>{item.menu}</Link>  
            </MenuLink>;
          }
        })}
 
        {!authenticated && <LoginSection onClick={()=>navigate('/home')}> Login</LoginSection>}
        {authenticated == true && <LoginSection onClick={()=>{setUnauthenticated();navigate('/home')}}> Logout</LoginSection>}

      </RectangleGroup>

      {/* <Image3Icon alt="" src="/image-3@2x.png" /> */}
      {/* {authenticated ? (
        <Link to='/auth/logout'>Logout</Link>
      ) : (
        <Link to='/auth/login'>Login</Link>
      )} */}
    </HomeRoot>
  );
};
